<template>
    <div class="sidebar-container">
        <!-- <div class="sidebar-close" @click="handleClickOutside">
            <svg-icon icon-class="sidebar-close" />
        </div> -->
        <div class="user-handle">
            <div v-if="userInfo && userInfo.avatar">
                <div class="userinfo">
                    <div class="photo">
                        <Images fit="cover" :src="userInfo.avatar" />
                    </div>
                    <div class="name">
                        {{ userInfo.real_name }}
                    </div>
                </div>
                <div class="user-menu">
                    <a :class="isIndex == 9 ? 'cur' : ''" href="javascript:void(0);" @click.stop="goPage('/ucenter/editPersonalInformation',9)">
                        我的主页
                    </a>
                    <a :class="isIndex == 10 ? 'cur' : ''" href="javascript:void(0);" @click.stop="goPage('/ucenter/index',10)">
                        个人中心
                    </a>
                    <a href="javascript:void(0);" @click.stop="signOut">
                        退出登录
                    </a>
                </div>
            </div>
            <div class="not-login-panel" v-else>
                <div class="photo">
                    <Images fit="cover" :src="defaultLogo" :lazyLoad="0"/>
                </div>
                <div class="handle-btn-con">
                    <a :class="isIndex == 8 ? 'cur' : ''" href="javascript:;" @click.stop="goPage('/login',8)">
                        登录
                    </a>
                    <a :class="isIndex == 7 ? 'cur' : ''" href="javascript:;" @click.stop="goPage('/login/register',7)">
                        注册
                    </a>
                </div>
            </div>
        </div>
        <ul class="main-nav">
            <li :class="isIndex == 0 ? 'cur' : ''" @click.stop="goPage('/index', 0)">
                <a href="javascript:void(0);">
                    首页
                </a>
            </li>
            <li :class="isIndex == 2 ? 'cur' : ''" @click.stop="goPage('/mall/talents', 2)">
                <a href="javascript:void(0);">
                    科创库
                </a>
            </li>
            <li :class="isIndex == 3 ? 'cur' : ''" @click.stop="goPage('/mall/demand/index', 3)">
                <a href="javascript:void(0);">
                    需求大厅
                </a>
            </li>
            <li :class="isIndex == 1 ? 'cur' : ''" @click.stop="goPage('/meeting/index', 1)">
                <a href="javascript:void(0);">
                    科创路演
                </a>
            </li>
            <li :class="isIndex == 4 ? 'cur' : ''" @click.stop="goPage('/sns/list', 4)">
                <a href="javascript:void(0);">
                    科创圈
                </a>
            </li>
            <li :class="isIndex == 5 ? 'cur' : ''" @click.stop="goPage('/video/index', 5)">
                <a href="javascript:void(0);">
                    科创微视
                </a>
            </li>
            <li :class="isIndex == 6 ? 'cur' : ''" @click.stop="goPage('/news/index', 6)">
                <a href="javascript:void(0);">
                    科创前沿
                </a>
            </li>
        </ul>
    </div>
</template>
<script>
    import { mapState } from 'vuex';
    import { cacheUserData,clearCachedUserData } from "@/assets/scripts/getUserData";
    import notLoginLogo from "@/assets/images/not-login-logo.png";
    export default {
        name: 'Sidebar',
        data() {
            return {
                isIndex: 0,
                defaultLogo:notLoginLogo,
                userInfo: {}
            }
        },
        computed: {
            ...mapState({
                sidebar: state => state.app.sidebar
            }),
            classObj() {
                return {
                    'sidebar-hide': !this.sidebar.opened,
                    'sidebar-show': this.sidebar.opened,
                    withoutAnimation: this.sidebar.withoutAnimation
                }
            }
        },
        created() {
            // 根据是否获取到token。如果有token才去获取用户信息
            let {token,sidebar:{currNavIndex}} = this.$store.getters;

            // 如果是在app中。就去获取token。然后设置到本地
            if(window.sma.isApp.innovationChina){
                token = window.sma.getToken().token;
                this.$store.dispatch('user/setToken', token);
            }else{
                // 当不是在app中,并且已经登录了。才调用这个接口获取信息
                if(token){
                    this.getUserInfo();
                }
            }
            this.isIndex = currNavIndex;
        },
        methods: {
            handleClickOutside() {
                this.$store.dispatch('app/closeSideBar', { withoutAnimation: false });
            },
            goPage(path, type) {
                this.$router.push({ 'path': path });
                if (type >= 0) {

                    this.isIndex = type;
                    this.$store.dispatch("app/changeNavIndex",type);
                }
                this.handleClickOutside();
            },
            signOut() {
                // 清空当前的token
                this.$store.dispatch("user/resetToken");
                // 然后跳转回首页
                this.$router.push("/");
                this.userInfo = null;
                // 清空之前已经保存的用户信息
                clearCachedUserData();
 
                // 关闭左侧的信息弹窗
                this.$store.dispatch("app/changeNavIndex", 0);
                this.$store.dispatch('app/closeSideBar', { withoutAnimation: false });
                // const script = document.createElement('script');
                // script.type = 'text/javascript';

                // // 传参一个回调函数名给后端，方便后端返回时执行这个在前端定义的回调函数
                // script.src = location.origin;
                // document.head.appendChild(script);

                // const scriptKczg = document.createElement('script');

                // scriptKczg.type = 'text/javascript';

                // // 本地 退出
                // scriptKczg.src = location.origin +"/account/loginOut";
                // document.head.appendChild(scriptKczg);

                // setTimeout(function() {
                //     window.location.href = location.origin;
                // }, 100)
            },
            getUserInfo() {
                cacheUserData().then(data=>{
                    this.userInfo = data;
                })
            }
        }
    };

</script>
